import { getPatient } from 'library/auth';

const SavedSignature = ({ url, signedOn }) => (
  <div className="mt-8 border-t border-gray-200 pt-5">
    <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-secondary-400">Patient signature</p>

    <img src={url} alt="Patient signature" className="mt-2 h-16 max-w-full object-contain" />

    <div className="mt-1 max-w-xs border-b border-secondary-900" />

    <p className="mt-2 text-sm font-semibold text-secondary-900">{getPatient()?.full_name}</p>
    <p className="text-xs text-secondary-500">{['Signed electronically', signedOn && `on ${signedOn}`].filter(Boolean).join(' ')}</p>
  </div>
);

export default SavedSignature;
